import { render } from "./NewsItemClassForm.vue?vue&type=template&id=2406a89f"
import script from "./NewsItemClassForm.vue?vue&type=script&lang=js"
export * from "./NewsItemClassForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QInput});
